module.exports = __webpack_public_path__ + "static/media/pl10.d3e5abf7.svg";